import { render, staticRenderFns } from "./LookUpCtrl.vue?vue&type=template&id=64c47cd3&"
import script from "./LookUpCtrl.vue?vue&type=script&lang=js&"
export * from "./LookUpCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports